import { Component, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements AfterViewInit{
  @ViewChildren('elfsightApp') elfsightApps!: QueryList<ElementRef>;
   // state loading untuk tiap widget
  isLoading: boolean[] = [];
  isLoadingDone: boolean[] = [];

  ngAfterViewInit(): void {
    this.elfsightApps.forEach((elfsightApp, index) => {
      this.isLoading[index] = true;
      this.isLoadingDone[index] = false;

      const observer = new MutationObserver(() => {
        if (elfsightApp.nativeElement.childNodes.length > 0) {
          this.finishLoading(index);
          observer.disconnect();
        }
      });

      observer.observe(elfsightApp.nativeElement, { childList: true, subtree: true });
    });
  }

  finishLoading(index: number): void {
    this.isLoadingDone[index] = true;
    setTimeout(() => {
      this.isLoading[index] = false;
    }, 1000);
  }
}
